import { Component, OnInit } from '@angular/core';
import { appSettings } from '@configs/app-settings.config';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Component({
	selector: 'app-footer',
	styleUrls: ['./footer.component.scss'],
	templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
	appSettings: any;
	user: any;
	constructor(private authenticationService: AuthenticationService) {
	}
	ngOnInit() {
		this.appSettings = appSettings
		this.authenticationService.getUserInfo()
			.subscribe((users: any) => {
				this.user = users;
			});
	}

	getYear() {
		return new Date().getFullYear();
	}

	getBetaTag() {
		if (!this.user.domain.toLowerCase().includes("randstad")) {
			return "beta";
		}
	}
}
